import { render, staticRenderFns } from "./CDContributors.vue?vue&type=template&id=5bba54ba&scoped=true"
import script from "./CDContributors.vue?vue&type=script&lang=ts"
export * from "./CDContributors.vue?vue&type=script&lang=ts"
import style0 from "./CDContributors.vue?vue&type=style&index=0&id=5bba54ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba54ba",
  null
  
)

export default component.exports